import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { getApiLanguage, VISIME_LANGUAGE_CHANGED, VISIME_UI_LANGUAGE_KEY } from '../../config/apiLanguage';
import { authScreen } from './authScreenStyles';
import { useT } from '../../i18n/useT';

const LANGUAGES = [
  { code: 'en' as const, label: 'EN' },
  { code: 'de' as const, label: 'DE' },
];

export default function AuthPreferencesBar() {
  const t = useT();
  const [lang, setLang] = useState<'en' | 'de'>(getApiLanguage() === 'de' ? 'de' : 'en');

  useEffect(() => {
    const onLang = () => setLang(getApiLanguage() === 'de' ? 'de' : 'en');
    window.addEventListener(VISIME_LANGUAGE_CHANGED, onLang);
    return () => window.removeEventListener(VISIME_LANGUAGE_CHANGED, onLang);
  }, []);

  const setLanguage = (code: 'en' | 'de') => {
    localStorage.setItem(VISIME_UI_LANGUAGE_KEY, code);
    window.dispatchEvent(new Event(VISIME_LANGUAGE_CHANGED));
    setLang(code);
  };

  return (
    <Box
      role="group"
      aria-label={t('languageAria')}
      sx={{
        display: 'inline-flex',
        p: 0.3,
        borderRadius: authScreen.pillRadius,
        border: `1px solid ${authScreen.glassBorder}`,
        bgcolor: authScreen.glass,
        backdropFilter: 'blur(12px)',
      }}
    >
      {LANGUAGES.map(({ code, label }) => {
        const active = lang === code;
        return (
          <Box
            key={code}
            component="button"
            type="button"
            aria-pressed={active}
            onClick={() => setLanguage(code)}
            sx={{
              minWidth: 40,
              py: 0.55,
              px: 1.1,
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer',
              fontFamily: authScreen.font,
              fontSize: '0.75rem',
              fontWeight: active ? 600 : 500,
              color: active ? authScreen.text : authScreen.textMuted,
              bgcolor: active ? 'rgba(255,255,255,0.1)' : 'transparent',
              transition: 'all 0.15s ease',
            }}
          >
            {label}
          </Box>
        );
      })}
    </Box>
  );
}
